// extracted by mini-css-extract-plugin
module.exports = {"root":"IndicatorBadge_root__2GN7M","border":"IndicatorBadge_border__1zsPU","square":"IndicatorBadge_square__PDnAo","circle":"IndicatorBadge_circle__UQZCC"};